import { DatePicker } from 'antd'
import { useEffect, useRef, useState } from 'react'

const { RangePicker } = DatePicker

type PeriodoRangePickerProps = React.ComponentProps<typeof RangePicker>

/**
 * RangePicker de periodo com selecao "do zero" SEM filtrar na hora:
 * - Ao ABRIR, esvazia os campos (selecao visual) para o usuario escolher um range novo
 *   comecando pelo "Inicio" — mas NAO comita nada, entao os dados/graficos nao mudam ainda.
 * - So chama o onChange (que dispara o filtro) quando o usuario escolhe o RANGE COMPLETO.
 * - Se fechar sem escolher, restaura o periodo que estava.
 * O valor "de verdade" continua vindo de props.value (ex.: compartilhado via localStorage).
 */
export default function PeriodoRangePicker(props: PeriodoRangePickerProps) {
  const { value, onChange, onOpenChange, ...rest } = props

  // Valor APENAS visual do picker (pode ficar vazio durante a edicao sem afetar o filtro).
  const [interno, setInterno] = useState<PeriodoRangePickerProps['value']>(value)
  const abertoRef = useRef(false)
  const escolheuRef = useRef(false)

  // Enquanto fechado, espelha o valor externo (ex.: mudou em outra tela / default).
  useEffect(() => {
    if (!abertoRef.current) setInterno(value)
  }, [value])

  const handleOpenChange = (open: boolean) => {
    abertoRef.current = open
    if (open) {
      escolheuRef.current = false
      setInterno(null) // abre vazio -> primeira data clicada vira o novo "Inicio"
    } else if (!escolheuRef.current) {
      setInterno(value) // fechou sem concluir -> volta o periodo anterior (nao filtra)
    }
    onOpenChange?.(open)
  }

  const handleChange = (dates: any, strings: any) => {
    escolheuRef.current = true
    setInterno(dates)
    onChange?.(dates, strings) // comita e filtra so com o range completo (ou ao limpar no X)
  }

  return <RangePicker {...rest} value={interno} onChange={handleChange} onOpenChange={handleOpenChange} />
}
